import { render, staticRenderFns } from "./RcaItem.vue?vue&type=template&id=421e07cb&scoped=true"
import script from "./RcaItem.vue?vue&type=script&lang=js"
export * from "./RcaItem.vue?vue&type=script&lang=js"
import style0 from "./RcaItem.vue?vue&type=style&index=0&id=421e07cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421e07cb",
  null
  
)

export default component.exports